<div fxLayout="column" fxLayoutAlign="start stretch">
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="15px">
        <div>
            The following table lists the courses which have been selected as requested courses for Dual Enrollment at
            {{ SelectedCollege.CollegeName }} for the {{ SelectedCollege.Term.TermCode | collegeTerm }}
            {{ SelectedCollege.Term.CollegeSchoolYear | collegeSchoolYear: SelectedCollege.CollegeID }} term:
        </div>
        <button type="button" fxFlex="1 0 auto" mat-raised-button color="primary" (click)="DownloadRefPDF()">
            Download Reference # Guide
        </button>
        <a *ngIf="SelectedCollege.CollegeID === 2" fxFlex="1 0 auto" mat-raised-button color="primary" 
            href="https://polk-prod-pxes02.banner.elluciancloud.com:8090/StudentRegistrationSsb/ssb/term/termSelection?mode=search" target="_blank">
            Search Polk State Reference #
            <mat-icon style="font-size: 18px; line-height: 18px; width: 18px; height: 18px; margin-left: 5px;">open_in_new</mat-icon>
        </a>
        <a *ngIf="SelectedCollege.CollegeID === 4" fxFlex="1 0 auto" mat-raised-button color="primary" 
            href="https://jics.seu.edu" target="_blank">
            Search SEU Reference #
            <mat-icon style="font-size: 18px; line-height: 18px; width: 18px; height: 18px; margin-left: 5px;">open_in_new</mat-icon>
        </a>
    </div>
    <mat-checkbox class="removedcheckbox" [(ngModel)]="ShowRemoved" *ngIf="HasRemovedRequests" (change)="UpdateFiltering()"
        >Show requests that have been removed</mat-checkbox
    >
    <mat-table class="bordered" #table [dataSource]="CoursesData" matSort matSortActive="Code" matSortDirection="asc">
        <ng-container matColumnDef="Code">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Course Code</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div>{{ course.FullCode }}</div>
                <button mat-raised-button color="primary" (click)="ShowCourseDescription(course)">View</button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CourseName">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Course Name</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">{{ course.Name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Credits">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Credits</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">{{ course.Credits | number: '1.1-1' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Required">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Required</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div [class.courserequired]="course.PriorityRequest">{{ course.PriorityRequest | yesNo }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateAdded">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Date Added</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div>{{ course.DateCreated | datefns: 'MM/DD/YYYY' }}</div>
                <div>{{ course.AddedByLastName | titleCase }}, {{ course.AddedByFirstName | titleCase }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateRemoved">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Date Removed</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div *ngIf="course.DateRemoved != null">{{ course.DateRemoved | datefns: 'MM/DD/YYYY' }}</div>
                <div *ngIf="course.DateRemoved != null">
                    {{ course.RemovedByLastName | titleCase }}, {{ course.RemovedByFirstName | titleCase }}
                </div>
                <div *ngIf="course.DateRemoved == null">N/A</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateApproved">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Date Approved</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div *ngIf="course.DateScheduled != null">{{ course.DateScheduled | datefns: 'MM/DD/YYYY' }}</div>
                <div *ngIf="course.DateScheduled != null">
                    {{ course.ScheduledByLastName | titleCase }}, {{ course.ScheduledByFirstName | titleCase }}
                </div>
                <div *ngIf="course.DateScheduled == null">N/A</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Status</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div>{{ course | courseRequestStatus: SelectedCollege.FormStatus }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ReferenceNum">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Reference #</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div *ngIf="course.ReferenceNumber">{{ course.ReferenceNumber }}</div>
                <div *ngIf="course.CountyTaught">PCSD Taught</div>
                <button
                    mat-raised-button
                    color="primary"
                    *ngIf="!AsParent && course.DateRemoved == null"
                    (click)="SetCourseReferenceNumber(course)"
                >
                    Update<br />Ref. #
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="AltReferenceNum">
            <mat-header-cell *matHeaderCellDef class="centered" mat-sort-header>Alternative Section Reference #</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div *ngIf="course.AltReferenceNumber">{{ course.AltReferenceNumber }}</div>
                <button
                    mat-raised-button
                    color="primary"
                    *ngIf="!AsParent && course.DateRemoved == null"
                    (click)="SetCourseAltReferenceNumber(course)"
                >
                    Update<br />Alt. Ref. #
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let course" class="centered">
                <div
                    *ngIf="
                        SelectedCollege &&
                        (SelectedCollege.FormStatus !== 10 || AsDistrictAdmin) &&
                        SelectedCollege.HistoricalRecord !== true
                    "
                >
                    <button
                        mat-raised-button
                        color="primary"
                        *ngIf="(AsAdvisor || AsCollegeAdmin) && course.DateRemoved == null && course.DateScheduled == null"
                        (click)="ApproveCourseChoice(course)"
                    >
                        Approve
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        *ngIf="(AsAdvisor || AsCollegeAdmin) && course.DateRemoved == null && course.DateScheduled != null"
                        (click)="ApproveCourseChoice(course)"
                    >
                        Update
                    </button>
                    <button
                        mat-raised-button
                        color="warn"
                        *ngIf="course.DateRemoved == null && (course.DateScheduled == null || AsDistrictAdmin)"
                        (click)="RemoveCourseChoice(course)"
                    >
                        Remove
                    </button>
                    <button
                        mat-raised-button
                        color="warn"
                        *ngIf="
                            course.DateRemoved != null &&
                            course.DateScheduled == null &&
                            (AsCounselor || AsSchoolAdmin || AsAdvisor || AsCollegeAdmin || AsDistrictAdmin || AsDeveloper)
                        "
                        (click)="UndoRemoveCourseChoice(course)"
                    >
                        Undo Remove
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoCourses">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let course">
                <em>No active course requests have been entered for this college term.</em>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef>Course Request(s)</mat-header-cell>
            <mat-cell *matCellDef="let course">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Course Code</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div>{{ course.FullCode }}</div>
                            <button mat-raised-button color="primary" (click)="ShowCourseDescription(course)">View</button>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Course Name</form-label>
                        <div>{{ course.Name }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Credits</form-label>
                        <div>{{ course.Credits | number: '1.1-1' }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Required</form-label>
                        <div [class.courserequired]="course.PriorityRequest">{{ course.PriorityRequest | yesNo }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Date Added</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div>{{ course.DateCreated | datefns: 'MM/DD/YYYY' }}</div>
                            <div>{{ course.AddedByLastName | titleCase }}, {{ course.AddedByFirstName | titleCase }}</div>
                        </div>
                    </div>
                    <div *ngIf="ShowRemoved" fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Date Removed</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div *ngIf="course.DateRemoved != null">{{ course.DateRemoved | datefns: 'MM/DD/YYYY' }}</div>
                            <div *ngIf="course.DateRemoved != null">
                                {{ course.RemovedByLastName | titleCase }}, {{ course.RemovedByFirstName | titleCase }}
                            </div>
                            <div *ngIf="course.DateRemoved == null">N/A</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Date Approved</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div *ngIf="course.DateScheduled != null">{{ course.DateScheduled | datefns: 'MM/DD/YYYY' }}</div>
                            <div *ngIf="course.DateScheduled != null">
                                {{ course.ScheduledByLastName | titleCase }}, {{ course.ScheduledByFirstName | titleCase }}
                            </div>
                            <div *ngIf="course.DateScheduled == null">N/A</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Status</form-label>
                        <div>{{ course | courseRequestStatus: SelectedCollege.FormStatus }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Reference #</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div *ngIf="course.ReferenceNumber">{{ course.ReferenceNumber }}</div>
                            <div *ngIf="course.CountyTaught">PCSD Taught</div>
                            <button
                                mat-raised-button
                                color="primary"
                                *ngIf="!AsParent && course.DateRemoved == null"
                                (click)="SetCourseReferenceNumber(course)"
                            >
                                Update Ref. #
                            </button>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Alternative Section Reference #</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div *ngIf="course.AltReferenceNumber">{{ course.AltReferenceNumber }}</div>
                            <button
                                mat-raised-button
                                color="primary"
                                *ngIf="!AsParent && course.DateRemoved == null"
                                (click)="SetCourseAltReferenceNumber(course)"
                            >
                                Update Alt. Ref. #
                            </button>
                        </div>
                    </div>
                    <div
                        *ngIf="SelectedCollege && SelectedCollege.FormStatus != 10 && SelectedCollege.HistoricalRecord !== true"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <button
                            mat-raised-button
                            color="primary"
                            *ngIf="(AsAdvisor || AsCollegeAdmin) && course.DateRemoved == null && course.DateScheduled == null"
                            (click)="ApproveCourseChoice(course)"
                        >
                            Approve
                        </button>
                        <button
                            mat-raised-button
                            color="primary"
                            *ngIf="(AsAdvisor || AsCollegeAdmin) && course.DateRemoved == null && course.DateScheduled != null"
                            (click)="ApproveCourseChoice(course)"
                        >
                            Update
                        </button>
                        <button
                            mat-raised-button
                            color="warn"
                            *ngIf="course.DateRemoved == null && (course.DateScheduled == null || AsDistrictAdmin)"
                            (click)="RemoveCourseChoice(course)"
                        >
                            Remove
                        </button>
                        <button
                            mat-raised-button
                            color="warn"
                            *ngIf="
                                course.DateRemoved != null &&
                                course.DateScheduled == null &&
                                (AsCounselor || AsSchoolAdmin || AsAdvisor || AsCollegeAdmin || AsDistrictAdmin || AsDeveloper)
                            "
                            (click)="UndoRemoveCourseChoice(course)"
                        >
                            Undo Remove
                        </button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: ShownColumns; let $even = even"
            [class.primarybackground50]="$even && row.DateRemoved == null"
            [class.red500-02]="row.DateRemoved != null"
        ></mat-row>
    </mat-table>

    <div>
        <strong>Total credit hours requested: {{ TotalCredits }}</strong>
    </div>
    <div
        class="warning warningblock"
        *ngIf="
            TotalCredits != null &&
            TotalCredits > 0 &&
            SelectedCollege &&
            SelectedCollege.DualEnrollmentProgram != null &&
            TotalCredits < SelectedCollege.DualEnrollmentProgram.MinimumCredits
        "
    >
        <em>This list currently contains fewer credit hours than the selected Dual Enrollment Program requires.</em>
    </div>
    <div
        class="warning warningblock"
        *ngIf="
            TotalCredits != null &&
            TotalCredits > 0 &&
            SelectedCollege &&
            SelectedCollege.DualEnrollmentProgram != null &&
            SelectedCollege.DualEnrollmentProgram.MaximumCredits != null &&
            TotalCredits > SelectedCollege.DualEnrollmentProgram.MaximumCredits
        "
    >
        <em>This list currently contains more credit hours than the selected Dual Enrollment Program allows.</em>
    </div>

    <!-- Eligibility Block -->
    <ng-container
        *ngIf="
            SelectedCollege.HistoricalRecord !== true &&
            (AsCounselor || AsSchoolAdmin || AsDistrictAdmin || AsDeveloper || AsAdvisor || AsCollegeAdmin || AsCollegeSupport)
        "
    >
        <div class="eligibilityblock" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
            <div fxLayout="column" fxLayoutAlign="start start">
                <mat-checkbox
                    [(ngModel)]="EligibilityByCourseGrade"
                    [disabled]="!(AsCounselor || AsSchoolAdmin || AsDistrictAdmin || AsDeveloper)"
                    (change)="CheckboxHandler($event)"
                >
                    <span *ngIf="!EligibilityByCourseGrade"
                        >Student eligibility requirement(s) have been met through grades in course(s). (Check box to select
                        courses.)</span
                    >
                    <span *ngIf="EligibilityByCourseGrade"
                        >Student eligibility requirement(s) have been met through grades in the following course(s):</span
                    >
                </mat-checkbox>
                <div>
                    <button
                        type="button"
                        *ngIf="
                            (AsCounselor || AsSchoolAdmin || AsDistrictAdmin || AsDeveloper) &&
                            EligibilityByCourseGrade &&
                            EligibilityByCourseGradeCoursesList &&
                            EligibilityByCourseGradeCoursesList.length
                        "
                        mat-raised-button
                        color="primary"
                        (click)="EligibilityChangeHandler()"
                    >
                        Make Changes To Courses
                    </button>
                </div>
            </div>
            <ul
                *ngIf="EligibilityByCourseGrade && EligibilityByCourseGradeCoursesList && EligibilityByCourseGradeCoursesList.length"
                class="margin-top-none"
            >
                <li *ngFor="let item of EligibilityByCourseGradeCoursesList">{{ item }}</li>
            </ul>
        </div>
    </ng-container>

    <!-- FastTrack Block -->
    <div
        class="fasttrackblock"
        *ngIf="
            SelectedCollege.HistoricalRecord !== true &&
            (AsCounselor || AsSchoolAdmin || AsAdvisor || AsCollegeAdmin || AsCollegeSupport || AsDistrictAdmin || AsDeveloper)
        "
    >
        <mat-checkbox [(ngModel)]="FastTrackAdvised" (change)="FastTrackChangeHandler($event)" [disabled]="AsCollegeSupport">
            <span
                >The student has been advised that FastTrack courses are not recommended for High School students taking Dual
                Enrollment classes. College courses taught in a shorter time frame contain the same expectations of content mastery as
                sections taught in a more traditional time frame. Taking FastTrack courses may result in a negative experience for the
                student in taking college courses and a lower semester grade that would negatively impact a student’s GPA and
                eligibility in a Dual Enrollment in subsequent semesters.</span
            >
        </mat-checkbox>
    </div>

    <!-- Action Buttons Block -->
    <div
        class="actionbar"
        *ngIf="SelectedCollege.HistoricalRecord !== true"
        fxLayout="row"
        fxLayoutAlign="start start"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <button
            *ngIf="
                AsStudent ||
                (AsAdvisor && AsCollegeAdmin && SelectedCollege.FormStatus >= 5 && SelectedCollege.FormStatus < 10) ||
                (!AsStudent && !AsAdvisor && !AsCollegeAdmin && !AsCollegeSupport && SelectedCollege.FormStatus >= 3)
            "
            mat-raised-button
            color="primary"
            (click)="SelectCourse()"
        >
            Add a course
        </button>

        <!-- Don't allow buttons by default if this has been submitted to college-->
        <!-- Counselor -->
        <button
            *ngIf="
                AsCounselor &&
                SelectedCollege.FormStatus <= 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses(false)"
        >
            Approve All Courses &amp; Submit To School Administrator
        </button>
        <button
            *ngIf="
                AsCounselor &&
                CanBypassAdmin &&
                SelectedCollege.FormStatus <= 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses(true)"
        >
            Approve All Courses &amp; Submit To College Advisor
        </button>
        <button
            *ngIf="
                AsCounselor &&
                SelectedCollege.FormStatus < 10 &&
                SelectedCollege.FormStatus > 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses(false)"
        >
            Approve All Courses &amp; Re-Submit To School Administrator
        </button>
        <button
            *ngIf="
                AsCounselor &&
                CanBypassAdmin &&
                SelectedCollege.FormStatus < 10 &&
                SelectedCollege.FormStatus > 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses(true)"
        >
            Approve All Courses &amp; Re-Submit To College Advisor
        </button>

        <!-- School Admin -->
        <button
            *ngIf="
                AsSchoolAdmin &&
                SelectedCollege.FormStatus < 10 &&
                SelectedCollege.FormStatus >= 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses()"
        >
            Approve All Courses &amp; Submit To College Advisor
        </button>

        <!-- Advisor and College Admin -->
        <button
            *ngIf="(AsAdvisor || AsCollegeAdmin) && SelectedCollege.FormStatus < 10"
            mat-raised-button
            color="warn"
            (click)="ReturnForm()"
        >
            Return Request To School
        </button>
        <button
            *ngIf="(AsAdvisor || AsCollegeAdmin) && SelectedCollege.FormStatus < 10"
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses()"
        >
            Mark All Courses As Scheduled &amp; Submit Record
        </button>

        <!-- District Admin / Developer -->
        <button
            *ngIf="
                (AsDistrictAdmin || AsDeveloper) &&
                SelectedCollege.FormStatus < 10 &&
                SelectedCollege.FormStatus >= 3 &&
                HasActiveRequests === true &&
                SelectedCollege.ParentHasApproved === true
            "
            mat-raised-button
            color="accent"
            (click)="ApproveAllCourses()"
        >
            Approve All Courses &amp; Submit To College Advisor
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/ui/courseselectionpanel/courseselectionpanel.component.html